import { RPCProcedure } from '@bits/rpc';
import useSWRImmutable from 'swr/immutable';

import { rpcClient } from '@/lib/api/rpc-client';

export const useCustomerUsers = () =>
  useSWRImmutable('/customers.users.list', () =>
    rpcClient.call('/customers.users.list')
  );

export const useCustomerInvites = () =>
  useSWRImmutable('/customers.users.invites.list', () =>
    rpcClient.call('/customers.users.invites.list')
  );

export type CustomerUserRole = 'role:org_owner' | 'role:user';

export const inviteCustomerUser = async (
  email: string,
  role: CustomerUserRole
) => {
  return rpcClient.call('/customers.users.invite', {
    email,
    role,
  });
};

export const finaliseCustomerUserInvite = async (
  token: string,
  payload: RPCProcedure<'/customers.users.create'>
) => {
  return rpcClient.call('/customers.users.create', payload, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const resendCustomerUserInvite = async (email: string) => {
  return rpcClient.call('/customers.users.invite.resend', {
    email,
  });
};

export const revokeCustomerUserInvite = async (email: string, role: string) => {
  return rpcClient.call('/customers.users.invite.revoke', {
    email,
    role,
  });
};
